// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MakeAnAppointment_centeredContainer__mLzNI {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}

.MakeAnAppointment_container__ouYRU {
  width: 100%;
  border-radius: 16px;
  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);
  display: flex;
  align-items: center;
}

.MakeAnAppointment_columnLeft__yhfrP {
  width: 50%;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 5%;
  margin-bottom: 5%;
  padding-left: 130px;
}
.MakeAnAppointment_columnRight__rf0pG {
  width: 50%;
  padding-left: 60px;
}

.MakeAnAppointment_subcolumnRight__wWEUb {
  padding: 10px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 4%;
}

.MakeAnAppointment_AppointmentImage__e0PMS {
  height: 320px;
  margin-bottom: 20px;
}

.MakeAnAppointment_row1__m2Ycp h3,
.MakeAnAppointment_row2__5uT9Q h3,
.MakeAnAppointment_row3__WK\\+Uk h3 {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #ffffff;
}

.MakeAnAppointment_row1__m2Ycp p,
.MakeAnAppointment_row2__5uT9Q p,
.MakeAnAppointment_row3__WK\\+Uk p {
  width: 55%;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0px;
  text-align: left;
  color: #ffffff;
  margin-left: 25px;
}

.MakeAnAppointment_row1__m2Ycp {
  margin-top: 9%;
}

.MakeAnAppointment_row2__5uT9Q {
  margin-top: 2%;
  margin-bottom: 1%;
}
.MakeAnAppointment_number__N9Zdh {
  margin-right: 10px;
}

.MakeAnAppointment_Heading__CSCnP {
  font-family: "Lato";
  font-size: 20px;
  font-weight: 800;
  text-align: left;
  color: #aed9fa;
}
.MakeAnAppointment_Subheading__tcY49 {
  font-family: "Lato";
  font-size: 36px;
  font-weight: 800;
  line-height: 43px;
  text-align: left;
  color: #ffffff;
  width: 55%;
  margin: 0px;
}
.MakeAnAppointment_Paragraph__XdVcz {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  color: #ffffff;
  width: 55%;
}
.MakeAnAppointment_btn__65jQV {
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 32px 0px #0904461f;
  width: 50%;
  margin-top: 20px;
}
.MakeAnAppointment_btnText__YynZ8 {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  color: #47a9f4;
}
.MakeAnAppointment_btn__65jQV:hover {
  cursor: pointer;
  background-color: #e6eaed;
}

@media screen and (max-width: 1330px) {
  .MakeAnAppointment_Paragraph__XdVcz,
  .MakeAnAppointment_Subheading__tcY49 {
    width: 70%;
  }
}

@media screen and (max-width: 1340px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 350px;
    margin-bottom: 50px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    margin-left: 1%;
  }
}

@media screen and (max-width: 1270px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 400px;
  }
}

@media screen and (max-width: 1240px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    margin-bottom: 70px;
  }
}

@media screen and (max-width: 1200px) {
  .MakeAnAppointment_container__ouYRU {
    flex-direction: column-reverse;
    padding-left: 50px;
    padding-top: 25px;
  }
  .MakeAnAppointment_columnRight__rf0pG {
    margin-left: 10%;
  }
}

@media screen and (max-width: 1000px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    margin-bottom: 80px;
  }
}

@media screen and (max-width: 965px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 440px;
  }
  .MakeAnAppointment_Subheading__tcY49 {
    width: 60%;
    font-size: 32px;
  }
}

@media screen and (max-width: 875px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 355px;
    margin-bottom: 35px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    width: 70%;
  }
}

@media screen and (max-width: 800px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 370px;
    margin-bottom: 35px;
  }
}

@media screen and (max-width: 735px) {
  .MakeAnAppointment_columnLeft__yhfrP {
    width: 65%;
  }
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 450px;
    margin-bottom: 90px;
  }
}

@media screen and (max-width: 650px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 455px;
    margin-bottom: 90px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    width: 75%;
  }
  .MakeAnAppointment_columnRight__rf0pG {
    width: 80%;
  }
}

@media screen and (max-width: 620px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 450px;
    margin-bottom: 80px;
  }
}

@media screen and (max-width: 570px) {
  .MakeAnAppointment_columnRight__rf0pG,
  .MakeAnAppointment_columnLeft__yhfrP {
    width: 100%;
  }

  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 400px;
    margin-bottom: 70px;
  }

  .MakeAnAppointment_container__ouYRU {
    min-width: 100%;
    padding-left: 70px;
  }
}

@media screen and (max-width: 510px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 420px;
    margin-bottom: 70px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    padding-right: 100px;
  }
  .MakeAnAppointment_columnRight__rf0pG {
    margin-left: 15%;
  }
}

@media screen and (max-width: 475px) {
  .MakeAnAppointment_row1__m2Ycp p,
  .MakeAnAppointment_row2__5uT9Q p,
  .MakeAnAppointment_row3__WK\\+Uk p {
    width: 71%;
  }
  .MakeAnAppointment_columnRight__rf0pG {
    margin-left: 5%;
  }
  .MakeAnAppointment_Paragraph__XdVcz,
  .MakeAnAppointment_Subheading__tcY49,
  .MakeAnAppointment_Heading__CSCnP,
  .MakeAnAppointment_btn__65jQV {
    width: 70%;
  }
}

@media screen and (max-width: 425px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 400px;
    margin-bottom: 70px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    padding-right: 130px;
  }
  .MakeAnAppointment_columnRight__rf0pG {
    margin-right: 13%;
    margin-left: 0;
    padding-left: 40px;
  }
  .MakeAnAppointment_Subheading__tcY49,
  .MakeAnAppointment_Paragraph__XdVcz {
    width: 86%;
  }
  .MakeAnAppointment_btn__65jQV {
    width: 83%;
  }
  .MakeAnAppointment_container__ouYRU {
    margin-top: 1400px;
  }
}

@media screen and (max-width: 380px) {
  .MakeAnAppointment_AppointmentImage__e0PMS {
    height: 400px;
    margin-bottom: 90px;
  }
  .MakeAnAppointment_columnLeft__yhfrP {
    margin-right: 10%;
  }
  .MakeAnAppointment_Subheading__tcY49,
  .MakeAnAppointment_Paragraph__XdVcz {
    width: 90%;
  }
  .MakeAnAppointment_container__ouYRU {
    margin-top: 1370px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MakeAnAppointment/MakeAnAppointment.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oEAAoE;EACpE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;EACtC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".centeredContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 70px;\n}\n\n.container {\n  width: 100%;\n  border-radius: 16px;\n  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);\n  display: flex;\n  align-items: center;\n}\n\n.columnLeft {\n  width: 50%;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-left: 5%;\n  margin-bottom: 5%;\n  padding-left: 130px;\n}\n.columnRight {\n  width: 50%;\n  padding-left: 60px;\n}\n\n.subcolumnRight {\n  padding: 10px;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 4%;\n}\n\n.AppointmentImage {\n  height: 320px;\n  margin-bottom: 20px;\n}\n\n.row1 h3,\n.row2 h3,\n.row3 h3 {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: left;\n  color: #ffffff;\n}\n\n.row1 p,\n.row2 p,\n.row3 p {\n  width: 55%;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0px;\n  text-align: left;\n  color: #ffffff;\n  margin-left: 25px;\n}\n\n.row1 {\n  margin-top: 9%;\n}\n\n.row2 {\n  margin-top: 2%;\n  margin-bottom: 1%;\n}\n.number {\n  margin-right: 10px;\n}\n\n.Heading {\n  font-family: \"Lato\";\n  font-size: 20px;\n  font-weight: 800;\n  text-align: left;\n  color: #aed9fa;\n}\n.Subheading {\n  font-family: \"Lato\";\n  font-size: 36px;\n  font-weight: 800;\n  line-height: 43px;\n  text-align: left;\n  color: #ffffff;\n  width: 55%;\n  margin: 0px;\n}\n.Paragraph {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 30px;\n  text-align: left;\n  color: #ffffff;\n  width: 55%;\n}\n.btn {\n  padding: 16px 24px 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  background-color: #ffffff;\n  box-shadow: 0px 4px 32px 0px #0904461f;\n  width: 50%;\n  margin-top: 20px;\n}\n.btnText {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #47a9f4;\n}\n.btn:hover {\n  cursor: pointer;\n  background-color: #e6eaed;\n}\n\n@media screen and (max-width: 1330px) {\n  .Paragraph,\n  .Subheading {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 1340px) {\n  .AppointmentImage {\n    height: 350px;\n    margin-bottom: 50px;\n  }\n  .columnLeft {\n    margin-left: 1%;\n  }\n}\n\n@media screen and (max-width: 1270px) {\n  .AppointmentImage {\n    height: 400px;\n  }\n}\n\n@media screen and (max-width: 1240px) {\n  .AppointmentImage {\n    margin-bottom: 70px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .container {\n    flex-direction: column-reverse;\n    padding-left: 50px;\n    padding-top: 25px;\n  }\n  .columnRight {\n    margin-left: 10%;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .AppointmentImage {\n    margin-bottom: 80px;\n  }\n}\n\n@media screen and (max-width: 965px) {\n  .AppointmentImage {\n    height: 440px;\n  }\n  .Subheading {\n    width: 60%;\n    font-size: 32px;\n  }\n}\n\n@media screen and (max-width: 875px) {\n  .AppointmentImage {\n    height: 355px;\n    margin-bottom: 35px;\n  }\n  .columnLeft {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .AppointmentImage {\n    height: 370px;\n    margin-bottom: 35px;\n  }\n}\n\n@media screen and (max-width: 735px) {\n  .columnLeft {\n    width: 65%;\n  }\n  .AppointmentImage {\n    height: 450px;\n    margin-bottom: 90px;\n  }\n}\n\n@media screen and (max-width: 650px) {\n  .AppointmentImage {\n    height: 455px;\n    margin-bottom: 90px;\n  }\n  .columnLeft {\n    width: 75%;\n  }\n  .columnRight {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 620px) {\n  .AppointmentImage {\n    height: 450px;\n    margin-bottom: 80px;\n  }\n}\n\n@media screen and (max-width: 570px) {\n  .columnRight,\n  .columnLeft {\n    width: 100%;\n  }\n\n  .AppointmentImage {\n    height: 400px;\n    margin-bottom: 70px;\n  }\n\n  .container {\n    min-width: 100%;\n    padding-left: 70px;\n  }\n}\n\n@media screen and (max-width: 510px) {\n  .AppointmentImage {\n    height: 420px;\n    margin-bottom: 70px;\n  }\n  .columnLeft {\n    padding-right: 100px;\n  }\n  .columnRight {\n    margin-left: 15%;\n  }\n}\n\n@media screen and (max-width: 475px) {\n  .row1 p,\n  .row2 p,\n  .row3 p {\n    width: 71%;\n  }\n  .columnRight {\n    margin-left: 5%;\n  }\n  .Paragraph,\n  .Subheading,\n  .Heading,\n  .btn {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 425px) {\n  .AppointmentImage {\n    height: 400px;\n    margin-bottom: 70px;\n  }\n  .columnLeft {\n    padding-right: 130px;\n  }\n  .columnRight {\n    margin-right: 13%;\n    margin-left: 0;\n    padding-left: 40px;\n  }\n  .Subheading,\n  .Paragraph {\n    width: 86%;\n  }\n  .btn {\n    width: 83%;\n  }\n  .container {\n    margin-top: 1400px;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .AppointmentImage {\n    height: 400px;\n    margin-bottom: 90px;\n  }\n  .columnLeft {\n    margin-right: 10%;\n  }\n  .Subheading,\n  .Paragraph {\n    width: 90%;\n  }\n  .container {\n    margin-top: 1370px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centeredContainer": `MakeAnAppointment_centeredContainer__mLzNI`,
	"container": `MakeAnAppointment_container__ouYRU`,
	"columnLeft": `MakeAnAppointment_columnLeft__yhfrP`,
	"columnRight": `MakeAnAppointment_columnRight__rf0pG`,
	"subcolumnRight": `MakeAnAppointment_subcolumnRight__wWEUb`,
	"AppointmentImage": `MakeAnAppointment_AppointmentImage__e0PMS`,
	"row1": `MakeAnAppointment_row1__m2Ycp`,
	"row2": `MakeAnAppointment_row2__5uT9Q`,
	"row3": `MakeAnAppointment_row3__WK+Uk`,
	"number": `MakeAnAppointment_number__N9Zdh`,
	"Heading": `MakeAnAppointment_Heading__CSCnP`,
	"Subheading": `MakeAnAppointment_Subheading__tcY49`,
	"Paragraph": `MakeAnAppointment_Paragraph__XdVcz`,
	"btn": `MakeAnAppointment_btn__65jQV`,
	"btnText": `MakeAnAppointment_btnText__YynZ8`
};
export default ___CSS_LOADER_EXPORT___;
